
import React, { Component } from 'react';
import { Modal, ModalBody, Card, CardBody, Button, CardHeader } from 'reactstrap';

var constants = require('../../../../../utils/domain/constants.js');
var snoozeUtil = require('../../../../../utils/domain/snoozeUtil.js');
var formatter = require('../../../../../utils/formatter/formatter.js');
var stringUtil = require('../../../../../utils/string/stringUtil.js');
var modifierDialogueUtil = require('../modifierDialogueUtil.js');

const defaultModifierItemBackColor = "#F8F8F8";
const defaultModifierItemForeColor = "#686868";

const translator = require("../../../../../utils/translator/translator.js");

class ModifierItemDialogue extends Component
{
    render()
    {
        var buttons = [];
        
        if (!this.props.hideCancelButton)
        {
            buttons.push(<Button color="secondary" className="btn-secondary" style={{marginTop:'0px', marginRight:'10px', minWidth:'100px'}} onClick={this.props.onCancel}>
                                {translator.getLabel("cancel")}
                        </Button>);
        }

        buttons.push(<Button disabled={!this.props.previousAllowed} color="warning" className="btn-warning" style={{marginTop:'0px', marginRight:'5px', minWidth:'100px'}} onClick={this.props.onPrevious}>
                            {translator.getLabel("previous")}
                    </Button>);

        buttons.push(<Button disabled={!modifierDialogueUtil.isModifierFullySatisfied(this.props.modifierViewModel, false)} color="primary" className="btn-primary" style={{marginTop:'0px', marginRight:'5px', minWidth:'100px'}} onClick={this.props.onNext}>
                        {translator.getLabel("next")}
                    </Button>);

        buttons.push(<Button disabled={!this.isFinishAllowed()} color="success" className="btn-success" style={{marginTop:'0px', minWidth:'100px'}} onClick={this.props.onSave}>
                        {translator.getLabel("finish")}
                    </Button>);

        return <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '80%'}}>
                        <div style={{userSelect:'none'}}>
                            <table width="100%">
                                <tr>
                                    <td>
                                        <table width="100%">
                                            <tr>
                                                <td valign="top">
                                                    {this.renderModifierOptions()}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <hr style={{marginTop:'10px', marginBottom:'10px'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="right">
                                        <div style={{marginLeft:'5px', marginRight:'5px', marginBottom:'10px'}}>
                                            {buttons}
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                </Modal>
    }

    renderModifierOptions()
    {
        var modifierViewModel = this.props.modifierViewModel;
        var underlyingModifier = modifierViewModel.underlyingModifier;

        var tableRows = [];
        var columnsRows = [];
        modifierViewModel.items.forEach (modifierItemViewModel =>
            {
                if (columnsRows.length == 3)
                {
                    tableRows.push(<tr>{columnsRows}</tr>);
                    columnsRows = [];
                }
                columnsRows.push(<td>{this.renderModifierOption(modifierViewModel, modifierItemViewModel)}</td>);
            });

        tableRows.push(<tr>{columnsRows}</tr>); 
        
        var modifierCaption = `${underlyingModifier.caption} (${underlyingModifier.min} / ${underlyingModifier.max})`
        return (<Card style={{marginLeft:'0px', marginTop:'0px', marginRight:'0px', marginBottom:'0px', paddingTop:'0px', paddingLeft:'0px', paddingRight:'0px', paddingBottom:'0px', borderWidth:'0px'}}>
                    <CardHeader style={{borderWidth:'2px', textAlign:'center'}}>
                        <strong>{modifierCaption}</strong>
                    </CardHeader>
                    <CardBody style={{marginLeft:'5px', marginRight:'5px', marginTop:'0px', marginBottom:'0px', padding:'0px'}}>
                        <div style={{maxHeight:"500px", overflowY:'auto'}}>
                            <table style={{width:'100%', marginTop:'10px'}}>
                                {tableRows}
                            </table>
                        </div>
                    </CardBody>
                </Card>)
    }

    renderModifierOption(modifierViewModel, modifierItemViewModel)
    {
        if (this.isModifierMemberDisabled(modifierItemViewModel.underlyingModifierItem))
            return this.renderDisabledModifierOption(modifierItemViewModel);


        var priceLabel = "N/A";

        if (modifierItemViewModel.underlyingModifierItem.price != null)
            priceLabel = formatter.convertToCurrencyFormat(modifierItemViewModel.underlyingModifierItem.price);
        
        var borderLeftColor = null;
        var borderLeftWidth = null;

        if (modifierItemViewModel.quantity > 0)
        {
            borderLeftColor = '#606060';
            borderLeftWidth = '10px'
        }

        var backgroundColor = modifierItemViewModel.underlyingModifierItem.backgroundColor;
        var foregroundColor = modifierItemViewModel.underlyingModifierItem.foregroundColor;

        if (stringUtil.isStringNullOrEmpty(backgroundColor) || stringUtil.isStringNullOrEmpty(foregroundColor))
        {
            backgroundColor = defaultModifierItemBackColor;
            foregroundColor = defaultModifierItemForeColor;
        }

        var multipleSelectionAllowed = modifierViewModel.underlyingModifier.max > 1;
        var canSingleItemBeSelectedMultipleTimes = modifierViewModel.underlyingModifier.canSameItemBeSelectedMultipleTimes;

        var quantityControl = null;
        if (multipleSelectionAllowed && canSingleItemBeSelectedMultipleTimes)
        {
            quantityControl = <td  style={{whiteSpace: "nowrap", verticalAlign:'top'}}>
                                    <table>
                                        <tr>
                                            <td onClick={()=>{
                                                                if (modifierItemViewModel.quantity == 0)
                                                                    return;

                                                                modifierItemViewModel.quantity = modifierItemViewModel.quantity - 1;
                                                                this.populateAutoSelections(modifierItemViewModel);
                                                                this.setState({});
                                                            }}>
                                                <Card style={{padding:'0px', margin:'0px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center'}}>
                                                        <div style={{marginTop:'-15px', fontSize:'1.8em', color:'#686868'}}>-</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>

                                            
                                            <td>

                                                <Card style={{padding:'0px', margin:'0px', marginLeft:'-2px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center', background:'#F8F8F8'}}>
                                                        <div style={{marginTop:'-10px', fontSize:'1.5em', color:'#686868'}}>{modifierItemViewModel.quantity}</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>

                                            <td onClick={()=>{
                                                                if (!this.canAddModifierMember(modifierItemViewModel.underlyingModifierItem))
                                                                    return;
                                                                    
                                                                if (this.maximumSelectionReached(modifierViewModel))
                                                                    return;

                                                                modifierItemViewModel.quantity = modifierItemViewModel.quantity + 1;
                                                                this.populateAutoSelections(modifierItemViewModel);

                                                                if (this.maximumSelectionReached(modifierViewModel))
                                                                    this.props.onNext();
                                                                else
                                                                    this.setState({});
                                                            }}>

                                                <Card style={{padding:'0px', margin:'0px', marginLeft:'-2px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center'}}>
                                                        <div style={{marginTop:'-15px', fontSize:'1.8em', color:'#686868'}}>+</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>
                                            
                                            
                                        </tr>
                                    </table>
                                </td>
        }

        return (<Card style={{marginLeft:'0px', marginRight:'0px', marginTop:'0px', marginBottom:'3px', minWidth:'20vw', 
                              background:backgroundColor, borderLeftColor:borderLeftColor, borderLeftWidth:borderLeftWidth}}>
                    <CardBody style={{padding:'10px'}}>
                        <table width="100%">
                            <tr>
                                <td style={{width:"100%", verticalAlign:'top'}} onClick={()=>
                                {

                                    if (modifierItemViewModel.quantity == 1)
                                    {
                                        modifierItemViewModel.quantity = 0;
                                        this.populateAutoSelections(modifierItemViewModel);
                                    }
                                    else
                                    {
                                        if (!this.canAddModifierMember(modifierItemViewModel.underlyingModifierItem))
                                            return;

                                        if (!multipleSelectionAllowed)
                                        {
                                            modifierViewModel.items.forEach(m => m.quantity = 0);
                                            modifierItemViewModel.quantity = 1;
                                            this.populateAutoSelections(modifierItemViewModel);
                                        }
                                        else
                                        {
                                            if (this.maximumSelectionReached(modifierViewModel))
                                                return;

                                            modifierItemViewModel.quantity = 1;
                                            this.populateAutoSelections(modifierItemViewModel);
                                        }
                                    }

                                    if (this.maximumSelectionReached(modifierViewModel))
                                        this.props.onNext();
                                    else
                                        this.setState({});
                                    }}>
                                    <div className="text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <strong>
                                            <div style={{color:foregroundColor}}>{modifierItemViewModel.underlyingModifierItem.caption}</div>
                                        </strong>
                                    </div>

                                    <div style={{marginTop:'3px', color:'red'}}>
                                        <small className="text-muted">
                                            <div style={{color:foregroundColor}}>{modifierItemViewModel.underlyingModifierItem.notes}</div>
                                        </small>
                                    </div>
                                    
                                    <div className="text-left text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <small>
                                            <div style={{color:foregroundColor}}>{priceLabel}</div>
                                        </small>
                                    </div>
                                </td>
                                {quantityControl}
                            </tr>
                        </table>
                    </CardBody>
                </Card>
        );
    }

    renderDisabledModifierOption(modifierItemViewModel)
    {
        var priceLabel = "N/A";

        if (modifierItemViewModel.underlyingModifierItem.price != null)
            priceLabel = formatter.convertToCurrencyFormat(modifierItemViewModel.underlyingModifierItem.price);
      
        var backgroundColor = '#808080';
        var foregroundColor = '#F8F8F8';

        var caption = modifierItemViewModel.underlyingModifierItem.caption;
        if (this.isModifierMemberSnoozed(modifierItemViewModel.underlyingModifierItem))
            caption = `${caption} - ${translator.getLabel("out_Of_stock")}`
        
        return (<Card style={{marginLeft:'5px', marginRight:'0px', marginTop:'0px', marginBottom:'3px', minWidth:'400px', 
                              background:backgroundColor}}>
                    <CardBody style={{padding:'10px'}}>
                        <table width="100%">
                            <tr>
                                <td style={{width:"100%", verticalAlign:'top'}}>
                                    <div className="text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <strong>
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{caption}</div>
                                        </strong>
                                    </div>

                                    <div style={{marginTop:'3px', color:'red'}}>
                                        <small className="text-muted">
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{modifierItemViewModel.underlyingModifierItem.notes}</div>
                                        </small>
                                    </div>
                                    
                                    <div className="text-left text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <small>
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{priceLabel}</div>
                                        </small>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </CardBody>
                </Card>
        );
    }

    isModifierMemberDisabled(modifierItem)
    {
        return this.isModifierMemberSnoozed(modifierItem);
    }

    canAddModifierMember(modifierItem)
    {
       return true;
    }

    isModifierMemberSnoozed(modifierItem)
    {
        return snoozeUtil.isItemSnoozedForSale(modifierItem, constants.SnoozeItemTypes.modifierItem, this.props.menu, this.props.sale);
    }

    maximumSelectionReached(modifierViewModel)
    {
        var quantity = 0;
        modifierViewModel.items.forEach (modifierItemViewModel =>
        {
            quantity = quantity + modifierItemViewModel.quantity;    
        });

        return quantity >= modifierViewModel.underlyingModifier.max;

    }

    isFinishAllowed()
    {
        var isSatisfied = true;
        this.props.modifiersViewModels.forEach (modifierViewModel =>
        {
            if (!modifierDialogueUtil.isModifierFullySatisfied(modifierViewModel, true))
                isSatisfied = false;
        })

        return isSatisfied;
    }

    populateAutoSelections(modifierItemViewModel, isRecursive)
    {
        if (modifierItemViewModel.quantity <= 0)
            return;
      
        if (isRecursive || modifierItemViewModel.quantity == 1)
        {
            for (var index = 0; index < modifierItemViewModel.modifiersViewModels.length; index++)
            {
                var modifierViewModel = modifierItemViewModel.modifiersViewModels[index];
                
                for (var iSubIndex = 0; iSubIndex < modifierViewModel.items.length; iSubIndex++)
                {
                    this.populateAutoSelection(modifierViewModel, modifierViewModel.items[iSubIndex]);
                }

            }
        }
    }

    populateAutoSelection(modifierViewModel, modifierItemViewModel)
    {
        modifierItemViewModel.quantity = 0;

        if (modifierViewModel.underlyingModifier.min == modifierViewModel.underlyingModifier.max && modifierViewModel.underlyingModifier.items.length == 1)
            modifierItemViewModel.quantity = modifierViewModel.underlyingModifier.min;
        else if (!stringUtil.isStringNullOrEmpty(modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity) &&  modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity > 0)
            modifierItemViewModel.quantity = modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity;

        this.populateAutoSelections(modifierItemViewModel, true);
    }
}

export default ModifierItemDialogue